export const EMPLOYEES_MODULE_NAME = "employees";
